import type { ReactNode } from "react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { BreadcrumbTooltipContent } from "@/domains/documents/components/atoms/BreadcrumbTooltipContent";
import type { FolderPathSegment } from "@/domains/documents/utils/folderPathResolver";

interface DocumentBreadcrumbHoverProps {
  /** Resolved folder-path segments for the document (WHA-3457). */
  segments: FolderPathSegment[] | null | undefined;
  buildingId: number;
  children: ReactNode;
}

/**
 * WHA-3457 — wraps an attached-document element in the same interactive
 * folder-path hover tooltip used on the /documents page. Clicking a folder
 * segment navigates to that exact folder on /projects. When the document has
 * no project/folder context (`segments` empty) the child renders bare.
 */
export function DocumentBreadcrumbHover({
  segments,
  buildingId,
  children,
}: DocumentBreadcrumbHoverProps) {
  if (!segments || segments.length === 0) return <>{children}</>;

  return (
    <HoverCard openDelay={300} closeDelay={200}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        side="bottom"
        align="start"
        className="w-fit max-w-lg break-words p-2 text-sm"
      >
        <BreadcrumbTooltipContent segments={segments} buildingId={String(buildingId)} />
      </HoverCardContent>
    </HoverCard>
  );
}
